import React, { Component } from 'react';

class About extends Component {
  render() {
    return (
        <div>
          <h1 className="mt-0 mb-4">Chi siamo</h1>
          <p className="caption">Coming soon...</p>
        </div>
    );
  }
}

export default About;
